import { get, patch, post, put } from 'src/helpers/api'
import { api } from '../api'
import * as T from 'src/store/types'

export const getITokenCampaignListAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    get(api.iTokenCampaign, payload).then(response => {
      const json = response.data
      commit(T.SET_ITOKEN_CAMPAIGN_LIST, {
        list: {
          data: json.data,
          total: json.total,
        },
      })
      resolve(json)
    })
  })
}

export const getITokenCampaignByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(`${api.iTokenCampaign}/${id}`).then(response => {
      const json = response.data.data
      commit(T.SET_ITOKEN_CAMPAIGN_DATA, {
        data: json,
      })
      resolve(response.data)
    })
  })
}

export const postITokenCampaignAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.iTokenCampaign, payload)
      .then(response => {
        const json = response.data.data
        commit(T.SET_ITOKEN_CAMPAIGN_DATA, {
          data: json,
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const patchITokenCampaignByIdAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    let { id } = payload
    let url = api.iTokenCampaignDeactivate.replaceAll('{id}', id)
    patch(url, payload).then(response => {
      const json = response.data.data
      commit(T.SET_ITOKEN_CAMPAIGN_DATA, {
        data: json,
      })
      resolve(response.data)
    })
  })
}

export const putITokenCampaignByIdAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    let { id } = payload
    let url = `${api.iTokenCampaign}/${id}`
    put(url, payload).then(response => {
      const json = response.data.data
      commit(T.SET_ITOKEN_CAMPAIGN_DATA, {
        data: json,
      })
      resolve(response.data)
    })
  })
}

export const getITokenRedemptionListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.iTokenRedemption, query).then(response => {
      const json = response.data.data
      commit(T.SET_ITOKEN_REDEMPTION_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const getITokenRedemptionByIdAction = ({ commit }, id) => {
  return new Promise(resolve => {
    get(`${api.iTokenRedemption}/${id}`).then(response => {
      const json = response.data.data
      commit(T.SET_ITOKEN_REDEMPTION_DATA, {
        data: json,
      })
      resolve(response.data)
    })
  })
}

export const postITokenRedemptionAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.iTokenRedemption, payload)
      .then(response => {
        const json = response.data.data
        commit(T.SET_ITOKEN_REDEMPTION_DATA, {
          data: json,
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getITokenVoucherListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.iTokenVoucher, query).then(response => {
      const json = response.data.data
      commit(T.SET_ITOKEN_VOUCHER_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const getITokenVoucherData = async ({ commit }, query) => {
  return new Promise(resolve => {
    let { id } = query
    get(api.iTokenVoucher + '/' + id, query).then(response => {
      const json = response.data
      commit(T.SET_ITOKEN_VOUCHER_DATA, json)
      resolve(json)
    })
  })
}

export const updateITokenVoucherAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    const payload = {
      status_id: query.status_id,
      expiry_date: query.expiry_date,
      remarks: query.remarks,
    }
    patch(api.iTokenVoucher + '/' + query.id, payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const createITokenVoucherAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.iTokenVoucher, payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getITokenAccumulateListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.iTokenAccumulateCalculation + query).then(response => {
      const json = response.data.data
      commit(T.SET_ITOKEN_ACCUMULATE_CALCULATION_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const postITokenAccumulateAction = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    let url = api.iTokenCampaignPostVouchers.replaceAll('{id}', id)
    patch(url, {})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const reportITokenAccumulateAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    get(api.iTokenCampaign + '/' + query + api.iTokenCampaignAccumulationReport)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const downloadITokenVoucherListAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    post(api.iTokenVoucherExport, payload).then(response => {
      resolve(response.data)
    })
  })
}
